module.exports = __webpack_public_path__ + "img/dt.9d33498f.png";